define('views/content/cd_personal',['require','views/base/item_page_view','typeahead','bloodhound','jquery.scrollbar','text!templates/content/cd_personal.html'],function(require){
    
    var BaseItemPageView = require('views/base/item_page_view');

    require('typeahead');
    require('bloodhound');
    require('jquery.scrollbar');

    var temp = require("text!templates/content/cd_personal.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'cd-manager-page page',
        basePath: 'cd-managers',
        titleKey: 'cd-personal',

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                mainForm : '#main-form',
                submitButton: '#submit-button',
                roleField: '.role-typeahead',
               
            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',

            'click @ui.submitButton': 'submitButtonClicked',
            'change @ui.phoneCountrySelect': 'phoneCountryChanged',
        },
        afterRender: function () {
            var _this = this;

            if (App.user.get('country_distributor') ) {
                //Setup typeahed for role field
                var roleTypeahedEngine = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.whitespace,
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: App.Config.apiBase + 'cd-roles/typeahead/',
                        replace: function(url, query) {
                            return url + ('?query=' + encodeURIComponent(_this.ui.roleField.val()));
                        }
                    },
                    identify: function(obj) {
                        return obj.id;
                    }
                });

                this.ui.roleField.typeahead({
                    minLength: 3
                }, {
                    name: 'roles',
                    source: roleTypeahedEngine,
                    display: 'role_name'
                });
                // Get selected role's id
                this.ui.roleField.bind('typeahead:select', function (ev, suggestion) {
                    _this.model.set('role', suggestion.id);
                });

            }
        },
        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'first_name': "required",
                    'last_name': "required",
                    'email': "required",
                    'phone_country': "required",
                    'phone_value': "required",
                    'role_name': "required"
                },
                messages: {
                    'first_name': App.polyglot.t('manager_first_name_required'),
                    'last_name': App.polyglot.t('manager_last_name_required'),
                    'email': App.polyglot.t('manager_email_required'),
                    'phone_country': App.polyglot.t('manager_phone_country_required'),
                    'phone_value': App.polyglot.t('manager_phone_value_required'),
                    'role_name': App.polyglot.t('personal_role_required')
                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

    });
});
